import React from 'react';

import { Tappable } from '@common/ui/general';
import Header from './Header';
import LoadingLayout from '@common/ui/layouts/LoadingLayout';
import Twitter from '@common/images/svg/twitter.svg';
import WhatsApp from '@common/images/svg/whatsApp.svg';
import Footer from './Footer';

function HappyFlowShareableBodyUI({
  isReady,
  sharableLinks,
  handleRequest,
  shareBtnIsVisible,
  handleTwitterShareRequest,
  handleWhatsAppShareRequest,
}) {
  return (
    <div className="column">
      {!isReady ? (
        <div className="psp-shareable-body__loading-layout">
          <LoadingLayout />
        </div>
      )
        : (
          <div className="psp-shareable-body">
            <div className="psp-shareable-body__header">
              <Header title="New achievement!" />
            </div>
            <div className="psp-shareable-body__image-container">
              <img
                src={sharableLinks.directLink}
                alt="psp_milestone"
              />
              {shareBtnIsVisible && (
                <div className="psp-shareable-body__platform-container">
                  <div
                    className="psp-shareable-body__share-platform-container"
                  >
                    <div className="psp-shareable-body__twitter">
                      <Tappable
                        style={{ backgroundColor: 'transparent' }}
                        key="twitter"
                        name="twitter"
                        onClick={handleTwitterShareRequest}
                      >
                        <img
                          src={Twitter}
                          alt="twitter"
                        />
                      </Tappable>
                    </div>

                    <div className="psp-shareable-body__whatsapp">
                      <Tappable
                        style={{ backgroundColor: 'transparent' }}
                        key="whatsapp"
                        name="whatsapp"
                        onClick={handleWhatsAppShareRequest}
                      >
                        <img
                          src={WhatsApp}
                          alt="whatsapp"
                        />
                      </Tappable>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="psp-shareable-body__share-btn-layout">
              <Footer
                isReady={isReady}
                sharableLinks={sharableLinks}
                handleRequest={handleRequest}
                handleWhatsAppShareRequest={handleWhatsAppShareRequest}
                handleTwitterShareRequest={handleTwitterShareRequest}
              />
            </div>
          </div>
        ) }
    </div>
  );
}

export default HappyFlowShareableBodyUI;
